import axios from 'axios'

const authRequest = (jwt, host='') => {
  return axios.post(`${host}/service/user/v1/session`, {},
    {
      headers: {
        'Authorization': `Bearer ${jwt}`,
        'BrightTALK-API-Client': 'cognito'
      }
    })

}

export default authRequest
